import Vue from 'vue'
import {
    CLEAR_ENTITIES,
    SET_ENTITIES,
    SET_APP_STATUS,
    SET_USER_ID,
    SOCKET_ONCLOSE,
    SOCKET_ONERROR,
    SOCKET_ONOPEN,
    SOCKET_RECONNECT,
    SOCKET_RECONNECT_ERROR,
    SET_AWARDED_DEVICES,
    SET_GEOFENCES,
    SET_DEVICES_VIEW,
    SET_FOCUS_DEVICE_ID,
    SET_MARKER,
    SET_SELECTED_CLASSIFICATION_ID,
    SET_TRACK_BOUNDS,
    SET_MODE,
    SET_IS_PLAYBACK_READY,
    SET_PLAYBACK_MARKERS,
    SET_PREVIOUS_SELECTED_CLASSIFICATION_ID,
    SET_SHOW_DISTANCE,
    SET_LIST_ORDER_BY,
    SET_AMOUNT_DISTANCE_MARKERS,
    SET_REVERT_DISTANCE_MARKERS,
    SET_SHOW_ALL_NAMES,
    SET_SHOW_TAILS,
    SET_IS_MANAGER,
    SET_EVENT_TIMES_DATA,
    SET_SELECTED_SERIE_NUMBER,
} from './mutations.type'

export default {
    [SET_ENTITIES](state, entities) {
        // eslint-disable-next-line guard-for-in
        for (const type in entities) {
            // eslint-disable-next-line guard-for-in
            for (const id in entities[type]) {
                // Patch update entity.
                const entity = {
                    ...(state.entities[type][id] ?? {}),
                    ...entities[type][id],
                }
                Vue.set(state.entities[type], id, entity)
            }
        }
    },
    [CLEAR_ENTITIES](state, entities) {
        // eslint-disable-next-line guard-for-in
        for (const type in entities) {
            for (const id of entities[type]) {
                // Delete entity.
                Vue.delete(state.entities[type], id)
            }
        }
    },
    [SET_APP_STATUS](state, appStatus) {
        state.appStatus = appStatus
    },
    [SET_USER_ID](state, userId) {
        state.userId = userId
    },
    [SET_AWARDED_DEVICES](state, deviceIds) {
        state.awardedDeviceIds = deviceIds
        sessionStorage.awardedDeviceIds = JSON.stringify(deviceIds)
    },
    [SET_GEOFENCES](state, geofencesIds) {
        state.geofencesIds = geofencesIds
    },
    [SET_MARKER](state, marker) {
        state.markers[marker.deviceId] = marker
    },
    [SET_DEVICES_VIEW](state, isHighlightedDevicesView) {
        state.isHighlightedDevicesView = isHighlightedDevicesView
    },
    [SET_FOCUS_DEVICE_ID](state, deviceId) {
        state.focusDeviceId = deviceId
    },
    [SOCKET_ONOPEN](state, event) {
        Vue.prototype.$socket = event.currentTarget
        state.socket.isConnected = true
    },
    [SOCKET_ONCLOSE](state) {
        state.socket.isConnected = false
    },
    [SOCKET_ONERROR](state, event) {
        console.error(state.socket, event)
    },
    [SOCKET_RECONNECT]() {
        console.log('reconnect')
    },
    [SOCKET_RECONNECT_ERROR](state) {
        state.socket.reconnectError = true
    },
    [SET_SELECTED_CLASSIFICATION_ID](state, id) {
        state.selectedClassificationId = id
    },
    [SET_SELECTED_SERIE_NUMBER](state, id) {
        state.selectedSerieNumber = id
    },
    [SET_TRACK_BOUNDS](state, trackBounds) {
        state.tracksBounds[trackBounds.id] = trackBounds
    },
    [SET_MODE](state, isLive) {
        state.isLiveMode = isLive
    },
    [SET_IS_PLAYBACK_READY](state, isPlaybackReady) {
        state.isPlaybackReady = isPlaybackReady
    },
    [SET_PLAYBACK_MARKERS](state, markers) {
        state.playbackMarkers = markers
    },
    [SET_PREVIOUS_SELECTED_CLASSIFICATION_ID](state, id) {
        state.previousSelectedClassificationId = id
    },
    [SET_SHOW_DISTANCE](state, isShow) {
        state.isShowDistanceMarkers = isShow
    },
    [SET_AMOUNT_DISTANCE_MARKERS](state, amount) {
        state.amountDistanceMarkers = amount
    },
    [SET_LIST_ORDER_BY](state, amount) {
        state.listOrderBy = amount
    },
    [SET_REVERT_DISTANCE_MARKERS](state, isRevert) {
        state.isRevertDistanceMarkers = isRevert
    },
    [SET_SHOW_ALL_NAMES](state, isShow) {
        state.isShowAllNames = isShow
    },
    [SET_SHOW_TAILS](state, isShow) {
        state.isShowDeviceTails = isShow
    },
    [SET_IS_MANAGER](state, manager) {
        state.manager = manager
    },
    [SET_EVENT_TIMES_DATA](state, data) {
        state.eventTimesData = data
    },

}
